/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_AddingInputs */

const en_admin_footer_badges_adding = /** @type {(inputs: Admin_Footer_Badges_AddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adding...`)
};

/**
* | output |
* | --- |
* | "Adding..." |
*
* @param {Admin_Footer_Badges_AddingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_adding = /** @type {((inputs?: Admin_Footer_Badges_AddingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_AddingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_adding(inputs)
});
export { admin_footer_badges_adding as "admin.footer_badges.adding" }